<div class="note-card-container">

  <a [routerLink]="link">
    <div class="note-card-content">
      <h1 class="note-card-title">{{title}}</h1>

      <div #bodyText class="note-card-body">
        <p>{{body}}</p>

        <div #truncator class="fade-out-truncation"></div>
      </div>
    </div>
  </a>

  <div (click)="onDelete()" class="x-button"></div>

</div>
